var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAlertCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 35C0 15.67 15.67 0 35 0C54.33 0 70 15.67 70 35C70 54.33 54.33 70 35 70C15.67 70 0 54.33 0 35ZM66.2162 35C66.2162 17.7598 52.2402 3.78378 35 3.78378C17.7598 3.78378 3.78378 17.7598 3.78378 35C3.78378 52.2402 17.7598 66.2162 35 66.2162C52.2402 66.2162 66.2162 52.2402 66.2162 35Z",
    fill: "#F29423"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1514 41.7246H33.8672L32.9766 22.873H38.042L37.1514 41.7246ZM32.7539 47.6992C32.7539 46.6849 33.0137 45.9736 33.5332 45.5654C34.0651 45.1449 34.7145 44.9346 35.4814 44.9346C36.236 44.9346 36.8792 45.1449 37.4111 45.5654C37.943 45.9736 38.209 46.6849 38.209 47.6992C38.209 48.6888 37.943 49.4062 37.4111 49.8516C36.8792 50.2845 36.236 50.501 35.4814 50.501C34.7145 50.501 34.0651 50.2845 33.5332 49.8516C33.0137 49.4062 32.7539 48.6888 32.7539 47.6992Z",
    fill: "#F29423"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlertCircle);
export default __webpack_public_path__ + "static/media/icon_alert_circle.e1e5c1b433ec7e0c2700b4547f0a5740.svg";
export { ForwardRef as ReactComponent };